module.exports = __webpack_public_path__ + "static/img/kong.6d03128.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/kong.png
// module id = 722
// module chunks = 1